// extracted by mini-css-extract-plugin
module.exports = {"tabs":"hBGf_rlLWIVI_cUgYdYmQ","tab":"_3UXZukuBLOIBMBaStG1-7a","active":"BKY5j6-D0YO9c8ADmTv8q"};